export const LIST_GAP_SIZES = {
  default: '8px',
  wide: '20px',
} as const

export type ListGapSize = keyof typeof LIST_GAP_SIZES

export const LIST_LOADING_PRESETS = {
  default: {
    listLoadingCount: 3,
    listGapSize: 'default' as ListGapSize,
  },
  supplementalDrawer: {
    listLoadingCount: 1,
    listGapSize: 'wide' as ListGapSize,
  },
} as const

export type ListLoadingPreset = keyof typeof LIST_LOADING_PRESETS

export const ListLayout = {
  gapSize: (size: ListGapSize = 'default') => LIST_GAP_SIZES[size],
  loadingPreset: (preset: ListLoadingPreset = 'default') =>
    LIST_LOADING_PRESETS[preset],
  resolveListOptions: (listOptions?: {
    listLoadingCount?: number
    listGapSize?: ListGapSize
    preset?: ListLoadingPreset
  }) => {
    const presetOptions = listOptions?.preset
      ? LIST_LOADING_PRESETS[listOptions.preset]
      : LIST_LOADING_PRESETS.default

    return {
      listLoadingCount:
        listOptions?.listLoadingCount ?? presetOptions.listLoadingCount,
      listGapSize: listOptions?.listGapSize ?? presetOptions.listGapSize,
    }
  },
} as const
